export default "__VITE_ASSET__BFTQPVQK__"